import { Controller } from "@hotwired/stimulus";

export default class QrToggleController extends Controller {
  static targets = ["panel", "chevron", "text"];

  connect() {
    this.open = false;
  }

  toggle() {
    this.open = !this.open;
    if (this.open == true ) {
      this.textTarget.textContent = "Hide QR"
    } else {
      this.textTarget.textContent = "Show QR"
    }

    this.panelTarget.classList.toggle("max-h-0", !this.open);
    this.panelTarget.classList.toggle("opacity-0", !this.open);

    this.panelTarget.classList.toggle("max-h-96", this.open);
    this.panelTarget.classList.toggle("opacity-100", this.open);

    this.chevronTarget.classList.toggle("rotate-180", this.open);
  }
}
